{
  "back": "Back",
  "backToList": "Back to list",
  "add": "Add",
  "cancel": "Cancel",
  "delete": "Delete",
  "addFile": "Add file",
  "save": "Save",
  "saveDraft": "Save as draft",
  "selectAll": "Select all",
  "validate": "Validate",
  "view": "Preview",
  "edit": "Edit",
  "download": "Download",
  "expand": "Expand",
  "collapse": "Collapse",
  "accept": "Accept",
  "withdrawAcceptance": "Withdraw acceptance"
}
